import { render } from "./Educationserver.vue?vue&type=template&id=bb75f2be&scoped=true"
import script from "./Educationserver.vue?vue&type=script&lang=js"
export * from "./Educationserver.vue?vue&type=script&lang=js"

import "./Educationserver.vue?vue&type=style&index=0&id=bb75f2be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb75f2be"]])

export default __exports__